import { Customer } from 'types/api/invoicing';

/** "First Last" (trimmed). */
export const customerName = (
  c: Pick<Customer, 'firstName' | 'lastName'>
): string => `${c.firstName} ${c.lastName ?? ''}`.trim();

/** "line1, city, COUNTRY" — the short address line for summaries. */
export const customerAddressSummary = (
  c: Pick<Customer, 'line1' | 'city' | 'country'>
): string => [c.line1, c.city, c.country].filter(Boolean).join(', ');
